<template>
  <div class="pdf-contaienr">
    <div
      ref="pdfContainer"
      class="pdfContainer"
    ></div>
  </div>
</template>
<script>
const pdfjsLib = require('pdfjs-signature-dist/build/pdf.js')

export default {
  name: 'pdf-protocol',
  props: {
    src: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      numPages: 0
    }
  },

  async mounted () {
    const MAX_IMAGE_SIZE = 1024 * 1024
    const CMAP_URL = 'https://unpkg.com/pdfjs-dist@2.1.266/cmaps/' // 显示签名信息
    const CMAP_PACKED = true
    const URL = this.src
    const pdfDocument = await pdfjsLib.getDocument({
      url: URL,
      maxImageSize: MAX_IMAGE_SIZE,
      cMapUrl: CMAP_URL,
      cMapPacked: CMAP_PACKED
    })
    for (let i = 1; i <= pdfDocument.numPages; i++) {
      await this.renderPDF(pdfDocument, i)
    }
    this.$bus.$emit('ready')
  },

  methods: {
    async renderPDF (pdfDocument, pageNum) {
      const container = this.$refs.pdfContainer
      const page = await pdfDocument.getPage(pageNum)
      const scale = 1
      const viewport = page.getViewport(scale)
      const pageContainer = document.createElement('div')
      pageContainer.setAttribute('id', 'page-' + (page.pageIndex + 1))
      pageContainer.setAttribute('style', 'position: relative')
      container.appendChild(pageContainer)
      const canvas = document.createElement('canvas')
      pageContainer.appendChild(canvas)
      const context = canvas.getContext('2d')
      canvas.height = viewport.height
      canvas.width = viewport.width
      canvas.style.width = '10rem'
      canvas.style.height = 'auto'
      const renderContext = {
        canvasContext: context,
        viewport: viewport
      }
      page.render(renderContext)
    }
  }
}
</script>
<style lang='less' >
@import "../../assets/less/mixin.less";

.pdfContainer {
  margin-top: 50px;
  canvas {
    transform: scale(1.1);
  }
}

</style>